import{componentFactory}from'../../../fc-core/src/lib';import LegendClass from'../_internal/components/legend/discrete';export default function(a){let b;componentFactory(a,LegendClass,'legend'),b=a.getChildren('legend')[0],b.configure(),a.addToEnv('legend',b),a.config.showLegend||b.remove()}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-charts/src/factories/legend.js
// module id = YXHX
// module chunks = 1